// extracted by mini-css-extract-plugin
export default {"container":"or_container__2d7vN","line":"or_line__xXDF-","title":"or_title__qnBs3"};